import React, { useState } from 'react';
import { LanguageProvider, useLanguage } from './hooks/useLanguage';
import { CyberpunkBackground } from './components/CyberpunkBackground';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsSection } from './components/StatsSection';
import { ServicesGrid } from './components/ServicesGrid';
import { PricingSection } from './components/PricingSection';
import { FeatureSection } from './components/FeatureSection';
import { CTASection } from './components/CTASection';
import { LanguageToggle } from './components/LanguageToggle';
import { PrivacyModal } from './components/PrivacyModal';
function AppContent() {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isAnyModalOpen, setIsAnyModalOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-black text-white selection:bg-cyan selection:text-black overflow-x-hidden font-sans" data-id="element-0">
      {/* Fixed Elements */}
      <CyberpunkBackground data-id="element-1" />
      <div className="scanlines" data-id="element-2" />
      <Header data-id="element-3" />
      <LanguageToggle data-id="element-4" />

      <main className="relative z-10" data-id="element-5">
        <Hero onModalStateChange={setIsAnyModalOpen} data-id="element-6" />
        <StatsSection data-id="element-7" />
        <section id="services" data-id="element-8">
          <ServicesGrid data-id="element-9" />
        </section>
        <section id="pricing" data-id="element-10">
          <PricingSection onModalStateChange={setIsAnyModalOpen} data-id="element-11" />
        </section>
        <section id="technology" data-id="element-12">
          <FeatureSection data-id="element-13" />
        </section>
        <section id="contact" data-id="element-14">
          <CTASection onModalStateChange={setIsAnyModalOpen} data-id="element-15" />
        </section>
      </main>

      <footer className={`relative z-10 bg-black py-8 border-t border-white/10 transition-opacity duration-300 ${isAnyModalOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} data-id="element-16">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-17">
          <div className="flex items-center" data-id="element-18">
            <img src="https://cdn.magicpatterns.com/uploads/bhj5bijn5GdNZbC3VKBdD1/Screenshot_2026-01-15_190938-removebg-preview.png" alt="TUIIT" className="h-6 w-auto" data-id="element-19" />
          </div>
          <div className="text-xs text-gray-600 font-mono" data-id="element-20">
            {t.footer.copyright}
          </div>
          <div className="flex gap-4 text-xs text-gray-500 font-mono" data-id="element-21">
            <button onClick={() => setIsPrivacyModalOpen(true)} className="hover:text-cyan transition-colors" data-id="element-22">
              {t.footer.privacy}
            </button>
            <a href="#" className="hover:text-cyan transition-colors" data-id="element-23">
              {t.footer.status}
            </a>
          </div>
        </div>
      </footer>

      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} data-id="element-24" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-25">
      <AppContent data-id="element-26" />
    </LanguageProvider>;
}